import { AxiosPromise } from 'axios';

import { LoginUser, MultiTenantsReqDto } from '../types';
import request from '../utils/request';

function getLoginUser(): AxiosPromise<LoginUser> {
  return request({
    url: `loginUser`,
    method: 'get',
    headers: { 'x-org-id': 'all' },
  });
}

function getMultiTenants() {
  return request({
    url: `localAccounts/multiTenants`,
    method: 'get',
  });
}

function switchMultiTenant(multiTenantsReqDto: MultiTenantsReqDto) {
  return request({
    url: `localAccounts/switch`,
    method: 'post',
    data: multiTenantsReqDto,
  });
}

function getAllDomains() {
  return request({
    url: `companies/domains`,
    method: 'get',
  });
}

function getV1EASSetupStatus(clpCompanyId: string) {
  return request({
    url: `clpCompanies/${clpCompanyId}/v1easSetUpStatus`,
    method: 'get',
    headers: { 'x-org-id': 'all' },
  });
}

function checkAccountMigrationInfo(email: string) {
  return request({
    url: `localAccounts/migrationInfo`,
    method: 'post',
    data: {
      email,
    },
  });
}

function isNeedProvisionNew(clpCompanyId: string) {
  return request({
    url: `clpCompanies/${clpCompanyId}/provisionNewFlag`,
    method: 'get',
  });
}

function isAllowUpgradeV1ECS(clpCompanyId: string) {
  return request({
    url: `clpCompanies/${clpCompanyId}/isAllowUpgradeV1ECS`,
    method: 'get',
  });
}

function getAccountType(userName: string) {
  return request({
    url: `users/accountType`,
    method: 'post',
    data: {
      username: userName,
    },
  });
}

function localLogin(
  userName: string,
  password: string,
  tenantId: string,
  captchaToken?: string
) {
  return request({
    url: `users/login`,
    method: 'post',
    data: {
      username: userName,
      password,
      tenantId,
      ...(captchaToken ? { captchaToken } : {}),
    },
  });
}

function localAutoLogin() {
  return request({
    url: `users/autoLogin`,
    method: 'get',
  });
}

function forgotPassword(username: string, token: string) {
  return request({
    url: `users/forgot`,
    method: 'post',
    data: {
      username,
      token,
    },
  });
}

function verifyAuthKey(authKey: string) {
  return request({
    url: `users/verifyAuthKey?authKey=${authKey}`,
    method: 'get',
  });
}

function resetPassword(password: string, authKey: string) {
  return request({
    url: `users/updatePassword`,
    method: 'post',
    data: {
      password,
      authKey,
    },
  });
}

function getInitConfiguration() {
  return request({
    url: `users/initConfiguration`,
    method: 'get',
  });
}

function updateInitConfiguration(dcSiteId: string) {
  return request({
    url: `users/initConfiguration`,
    method: 'post',
    data: {
      dcSiteId,
    },
  });
}

function isGmailInlinePreviewUser() {
  return request({
    url: `isGmailInlinePreviewUser`,
    method: 'get',
  });
}

function logout() {
  return request({
    url: `users/logout`,
    method: 'get',
  });
}

export default {
  getLoginUser,
  getMultiTenants,
  switchMultiTenant,
  getAllDomains,
  getV1EASSetupStatus,
  checkAccountMigrationInfo,
  isNeedProvisionNew,
  isAllowUpgradeV1ECS,
  getAccountType,
  localLogin,
  localAutoLogin,
  forgotPassword,
  verifyAuthKey,
  resetPassword,
  getInitConfiguration,
  updateInitConfiguration,
  isGmailInlinePreviewUser,
  logout,
};
